import {
  primaryColors,
  transparentColors,
} from "../../../../assets/styles/helpers/colors.styles";

export const navigationTabStyles = {
  // Only the selected tab is at full strength, so the current category reads
  // at a glance rather than only from the indicator under it.
  color: transparentColors.whiteShade6,
  fontWeight: 300,
  fontFamily: "Helvetica Neue",
  // Category names are written as the venue wrote them, not lowercased.
  textTransform: "none",
  padding: "0 0 0.375rem 0",

  "&:focus": {
    outline: "none",
  },
  "&.Mui-selected": {
    color: primaryColors.white,
  },
  "&.MuiButtonBase-root": {
    minWidth: 0,
    minHeight: 0,
  },
};

export const navigationTabWrapperStyles = {
  ".MuiTabs-scroller.MuiTabs-fixed": {
    overflowX: "scroll !important",
    height: "fit-content",
  },
  ".MuiTabs-flexContainer": {
    gap: "1rem",
  },
  "&.MuiTabs-root": {
    minWidth: 0,
    minHeight: 0,
  },
  ".MuiTabs-indicator": {
    backgroundColor: primaryColors.orange,
  },
};
